import Bestellung from "@/entities/common/bestellung"
import BstlArtikel from "@/entities/common/bstl_artikel"

export default class NachbestellungPending {
  id: string
  bestellZp: string
  bestellung: Bestellung
  artikelliste: BstlArtikel[] = []
  preislisten: any[] = []
  kommentare: string
}
